import React,{ useState, useCallback } from 'react';
import { useSelector, connect} from 'react-redux';
import { Divider } from 'rsuite';
import * as actionsPolicy  from '../../../../app/actions/policy';
import TalonSample from '../../../../_assets/img/TalonSample.png'
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import {camerasvg, downloadsvg, editsvg, picturesvg, infoRedsvg} from "../svg/iconDashSvg";
import OfferCard from './OfferCard';
import NuInsModal from '../elements/NuInsModal';
import {AccessMediaPrompt, CustomDrawerMedia, WebcamCapture, dataUrlToFile, UploadPicture} from '../elements/UploadHelpers';
import {insCompBgNames} from '../../../../app/common/types/insCompTypes';

const UplaodTalonPic = ({onBack, onForward, style, setTalonPicture}) => {

    const { selectedOffer } = useSelector(state => state.insOffers);
    const { insCompany, installments, totalAmountEUR, totalAmountLEVA } = selectedOffer || {};

  //  const { insCompany='uniqa', installments=['45.6','56.5'] } = selectedOffer || {}; // for testing

    const insCompanyNameBg = insCompBgNames[insCompany] ? insCompBgNames[insCompany] : null;

    const insVehicleInfo = useSelector(state => state.insVehicleInfo);
    const {talonPicture, initialData} = insVehicleInfo || {};
    const {data, contentType} = talonPicture || {};
    const {registered} = initialData || {};

    const [picture, setPicture] = useState({uploaded: contentType ? true : false, 
                                            data: data ? URL.createObjectURL(data) : null,
                                            contentType: contentType});

    const [chooseMedia, setChooseMedia] = useState(false);

    const [access, setAccess] = useState({camera:false, gallery:false});
    const [showPompt, setShowPrompt] = useState({camera:false, gallery:false});

    const [showUpload, setShowUpload] = useState(false) // Drawer for picture upload
    const [showTakePic, setShowTakePic] = useState(false) // Drawer for camera to take pictur

    const accessGrantedHandler = (field) => {
        setShowPrompt((prev) => ({...prev, [field]: false}));
        switch (field) {
            case 'camera':
                setShowTakePic(true); setShowUpload(false);
                return setAccess((prev) => ({...prev, camera: true}));
            case 'gallery':
                setShowTakePic(false); setShowUpload(true);
                return setAccess((prev) => ({...prev, gallery: true}));
            default:
                return 'Unknown stepIndex';
        }
    } ;

    const closeModal = (field) => {
        switch (field) {
            case 'chooseMedia':
                return setChooseMedia(false);
            case 'promptCamera':
                setShowPrompt((prev) => ({...prev, camera: false}))
                return //setAccess((prev) => ({...prev, camera: false}));
            case 'promptGallery':
                setShowPrompt((prev) => ({...prev, gallery: false}))
                return //setAccess((prev) => ({...prev, gallery: false}));
            case 'takePic':
                return setShowTakePic(false)
            default:
                return 'Unknown stepIndex';
        } 
    }

    

    const openModal = (event, field) => {
        event.stopPropagation();
        switch (field) {
            case 'chooseMedia':
                return setChooseMedia(true);
            default:
                return 'Unknown stepIndex';
        }
        
    }

    const toggleShowPic = () => {
        // setShowViewer(true)
        // setEditPicture(pictureloaded.picture)
    }

    const chooseMediaCamera = () => {
        setChooseMedia(false);
        if(!access.camera) return setShowPrompt((prev) => ({...prev, camera: true}));

        setShowTakePic(true);
    }

    const chooseMediaGallery = () => {
        setChooseMedia(false);
        if(!access.gallery) return setShowPrompt((prev) => ({...prev, gallery: true}));
        setShowUpload(true);
    }

    const onPicTaken = (image) => {
        setPicture({uploaded: true, data: image, contentType: 'image/png'});
        // const file = await dataUrlToFile(image, 'talonPic', 'image/png')
        // setTalonPicture(file, 'image/png');
        closeModal('takePic');
    }
    
    const onImageUpload = useCallback((image) => {
        if(image) {
            setPicture({uploaded: true, data: URL.createObjectURL(image.file), contentType: image.contentType});
           // setTalonPicture(image.file, image.contentType);
        }
        // console.log('uploaded', image?.contentType)
        setShowUpload(false);
    }, []);

    const submitHandler = async () => {
        if(picture.uploaded) {
            const file = await dataUrlToFile(picture.data, 'talonPic', picture.contentType)
            //console.log(file)
            setTalonPicture(file, picture.contentType);
        }
        onForward(8);
    }

    const goBack = () => {
        onBack(6)
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={2} steps={4} labels={steppLabels}/>              
            </div>
            <Divider style={{marginBottom: 0}}/>
            <OfferCard insCompany={insCompany} installments={installments} totalAmountEUR={totalAmountEUR} totalAmountLEVA={totalAmountLEVA} title="Избрана оферта"/>
            <div className="steps_container-form show-loading" >
                <h6 className="text-label" style={{marginTop: '2rem', marginLeft: '1.5rem'}}>Снимка на голям или малък талон</h6>
            </div>
            <div className="upload-talon-display">
                <div className="upload-talon-left" onClick={(event) => openModal(event, 'chooseMedia')}>                       
                    <div>{picture.uploaded ? editsvg : camerasvg}</div>
                    <p style={{textAlign:"center"}}>{picture.uploaded ? 'Редактирай' : 'Качи снимка'}</p> 
                </div> 
                <div className="upload-talon-right">
                    <img src={picture.uploaded ? picture.data : TalonSample} alt="sample talon" 
                            style={picture.uploaded ? {cursor: 'pointer'} : null}
                            onClick={ picture.uploaded ? toggleShowPic : null } />
                </div>                  
            </div>
            {(insCompany !== 'levins')
            ?<>
                <p style={{paddingLeft:"1.5rem", fontWeight:"600", marginBottom: '.3rem'}}>Информационен документ на {insCompanyNameBg}</p>

                <a href={`/files/conditions/${insCompany}.pdf`} target="_blank" rel="noreferrer" style={{paddingLeft:"1.5rem"}}>
                    <span>{downloadsvg}</span> Застраховка Гражданска Отговорност</a>
             </>
            : null}
            {!registered && (insCompany === 'dallbogg') &&
                <div style={{padding: '0 1.5rem', marginTop: '1rem'}}>
                    <p style={{display:"flex"}}><span style={{paddingTop:"5px",marginRight:"5px"}}>{infoRedsvg}</span> 
                    <span style={{padding:"2px",color:"#AA076B"}}>При сключване на 1-годишна полица за нерегистрирано МПС е необходимо в 30 дневен срок да ни изпратиш талона на автомобила, за да не бъде прекратена полицата</span></p>
                </div>
            }

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>


            {/* Modal to for choosing a media */}
            <NuInsModal show={chooseMedia} devider={true} textHeader="Изберете медия" onClose={() => closeModal('chooseMedia')} >
                <div className="select-media">
                    <div className="media-left" onClick={chooseMediaCamera}>
                        {camerasvg} 
                        <p>Камера</p>                       
                    </div>
                    <div className="media-center"></div>
                    <div className="media-right" onClick={chooseMediaGallery}>
                        {picturesvg}
                        <p>Галерия</p>
                    </div>             
                </div> 
            </NuInsModal>

            {/* Modal to allow permission to upload picture */}
            <NuInsModal show={showPompt.gallery} onClose={()=>closeModal('promptGallery')}>
                <AccessMediaPrompt icon={picturesvg}
                                   promptText="Позволи на приложението да достъпи Галерия" 
                                   onAccessGranted={()=>accessGrantedHandler('gallery')}
                                   onCancel={()=>closeModal('promptGallery')}/> 
            </NuInsModal>

            {/* Modal to allow permission and take picture using camera */}
            <NuInsModal show={showPompt.camera} onClose={()=>closeModal('promptCamera')}>
                <AccessMediaPrompt icon={picturesvg}
                                   promptText="Позволи на приложението да достъпи Камератa" 
                                   onAccessGranted={()=>accessGrantedHandler('camera')}
                                   onCancel={()=>closeModal('promptCamera')}/> 
            </NuInsModal>

            {/* component to take picture */}
            <CustomDrawerMedia show={showTakePic} onClose={()=>closeModal('takePic')} sizedraw="md">              
              <WebcamCapture onCapture={onPicTaken} onCancel={()=>closeModal('takePic')}/>
            </CustomDrawerMedia>
           {showUpload
            ? <UploadPicture onChange={onImageUpload} />
            : null
           }
                
        </div>
    )
}

export default connect(null, actionsPolicy)(UplaodTalonPic);


